import { Stack, Typography, useTheme } from "@mui/material";
import { Avatar, CheckBox } from "components";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { AddParticipantComponent } from "./AddParticipantComponent";
import { BillableToggleComponent, UserSearch } from "./CustomerUserSearch";

export const ChildTicketUserSearch = () => {
  const theme = useTheme();
  const { getValues, control } = useFormContext();
  return (
    <Stack sx={{ gap: "8px" }}>
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px 16px 8px 24px",
          borderRadius: "8px",
          backgroundColor: "#FFF",
        }}
      >
        <Typography variant="subtitle1">Customer</Typography>
        <Stack
          direction={"row"}
          sx={{
            borderRadius: "4px",
            border: `1px solid ${theme.palette.neutral["015"]}`,
            p: "4px 8px",
            gap: "8px",
            alignItems: "center",
          }}
        >
          <Avatar
            fullname={getValues("customer").customer_name}
            variants="sm"
          />
          <Typography variant="body-small">
            {getValues("customer").customer_name}
          </Typography>
        </Stack>
      </Stack>

      <Stack
        sx={{
          p: "12px 16px",
          width: "100%",
          borderRadius: "8px",
          backgroundColor: "#FFF",
          gap: "12px",
        }}
      >
        <Stack
          direction={"row"}
          sx={{
            gap: "24px",
          }}
        >
          <UserSearch type="child" />
        </Stack>
        <Stack
          direction={"row"}
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Stack direction={"row"} alignItems={"center"} gap="8px">
            <Controller
              name="showParticipants"
              control={control}
              render={({ field }) => (
                <CheckBox
                  checked={field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                />
              )}
            />
            <Typography variant="body-medium">Add more participants</Typography>
          </Stack>
          <BillableToggleComponent />
        </Stack>
        <AddParticipantComponent />
      </Stack>
    </Stack>
  );
};
